import React from 'react';

interface AuthLayoutProps {
  children: React.ReactNode;
}

// Backdrop photos crossfade behind the card (styles in sass/login.scss)
const BACKDROP_IMAGES = [
  '/images/login-grid/db-Drone-2.jpg',
  '/images/login-grid/Railway-Square-Dion-Robeson-08.jpg',
  '/images/login-grid/Gov---KRH-(4).jpg'
];

/**
 * Shared shell for the auth pages (login, forgot password, reset password):
 * a single centred card on a dark surface with dimmed project photography.
 */
const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => (
  <div className="auth-page">
    <div className="auth-page__backdrop" aria-hidden="true">
      {BACKDROP_IMAGES.map(src => (
        <div
          key={src}
          className="auth-page__photo"
          style={{ backgroundImage: `url("${src}")` }}
        />
      ))}
    </div>

    <div className="auth-card">
      <div className="auth-card__brand">
        <span className="auth-card__mark">
          <img src="/te-logo.png" alt="Terpkos Engineering" />
        </span>
        <span className="auth-card__wordmark">
          terpkos
          <em>engineering</em>
        </span>
      </div>
      {children}
    </div>
  </div>
);

export default AuthLayout;
